import axios from 'axios';

const shopAxios=axios.create({
  baseURL:process.env.VUE_APP_API_BASE_URL
})

shopAxios.interceptors.request.use(config => {
  const token = localStorage.getItem('a-token')
  if (token) {
    config.headers['ztwb-token'] = token // 让每个请求携带自定义 token 请根据实际情况自行修改
  }
  return config
}, err =>  Promise.reject(err));

//商城获取商品
export const getGoods = params => {return shopAxios.post('/goods/get', params).then(res=>res.data)};
//商城获取商品详细信息
export const getGoodsDetails = params => {return shopAxios.post('/goods/detail', params).then(res=>res.data)};
//获取地址列表
export const getAddressList = params => {return shopAxios.post('/address/get', params).then(res=>res.data)};
//创建收获地址
export const setAddress = params => {return shopAxios.post('/address/create', params).then(res=>res.data)};
//更新地址
export const updateAddressList = params => {return shopAxios.post('/address/update', params).then(res=>res.data)};
//删除地址
export const removeAddressList = params => {return shopAxios.post('/address/remove', params).then(res=>res.data)};
//下单接口
export const orderCreate = params => {return shopAxios.post('/order/create', params).then(res=>res.data)};
//商城付款接口
export const orderPayment = params => {return shopAxios.post('/order/payment', params).then(res=>res.data)};
//获取兑换券列表
export const getTicket = params => {return shopAxios.post('/ticket/get', params).then(res=>res.data)};
//获取订单列表
export const getOrderList = params => {return shopAxios.post('/order/get', params).then(res=>res.data)};
//获取活动信息接口
export const getEventInfo = params => {return shopAxios.post('/gift/get', params).then(res=>res.data)};
//获取单个活动信息 （匿名卡兑换拉取商品
export const getGiftInfo = params => {return shopAxios.post('/gift/info', params).then(res=>res.data)};
//获取商城首页中间项   选品分类查询
export const getCategory = params => {return shopAxios.post('/category/get', params).then(res=>res.data)};
//获取商城推荐列表
export const getChoice = params => {return shopAxios.post('/choice/get', params).then(res=>res.data)};
//记录用户操作
export const recordRouter  = params => {return shopAxios.post('/user/access', params).then(res=>res.data)};
//获取banner
export const getBanner  = params => {return shopAxios.post('/banner/get', params).then(res=>res.data)};
//退货申请创建
export const refundCreate  = params => {return shopAxios.post('/refund/create', params).then(res=>res.data)};
//查询退款申请是否已进行
export const refundGet  = params => {return shopAxios.post('/refund/get', params).then(res=>res.data)};
//获取商城我的信息
export const userInfo  = params => {return shopAxios.post('/user/info', params).then(res=>res.data)};
//绑定兑换券
export const couponBind  = params => {return shopAxios.post('/coupon/bind', params).then(res=>res.data)};
//检查卡号
export const checkCoupon  = params => {return shopAxios.post('/coupon/check', params).then(res=>res.data)};
//获取购物车内容
export const getCart  = params => {return shopAxios.post('/cart/get', params).then(res=>res.data)};
//加入购物车
export const addCart  = params => {return shopAxios.post('/cart/add', params).then(res=>res.data)};
//更新购物车信息
export const updateCart  = params => {return shopAxios.post('/cart/update', params).then(res=>res.data)};
//积分下单积分不足时调用
export const pointBuy  = params => {return shopAxios.post('/gift/point/buy', params).then(res=>res.data)};

export const recordInfo = params => {return shopAxios.post('/user/access',params).then(res=>res.data).catch(e => {console.log(e)})}
//查询特惠商品
export const choiceGet  = params => {return shopAxios.post('/choice/get', params).then(res=>res.data)};
//获取秒杀商品
export const FlashGoodsGet  = params => {return shopAxios.post('/flash/get', params).then(res=>res.data)};
//校验秒杀资格
export const checkFlashLimit  = params => {return shopAxios.post('/goods/sku/flash/get', params).then(res=>res.data)};
//获取活动（签到等）
export const activityGet  = params => {return shopAxios.post('/activity/get', params).then(res=>res.data)};
//取消订单
export const orderCancel  = params => {return shopAxios.post('/order/cancel', params).then(res=>res.data)};
//签到接口
export const activityCheck  = params => {return shopAxios.post('/activity/check', params).then(res=>res.data)};
//获得试卷列表
export const examListGet  = params => {return shopAxios.post('/exam/get', params).then(res=>res.data)};
//开始考试
export const examStart  = params => {return shopAxios.post('/user/exam/start', params).then(res=>res.data)};
//结束考试
export const examEnd  = params => {return shopAxios.post('/user/exam/end', params).then(res=>res.data)};
//获得用户考试列表
export const examGet  = params => {return shopAxios.post('/user/exam/get', params).then(res=>res.data)};
// 查看用户考试试卷题目和自己的答案
export const examDetail  = params => {return shopAxios.post('/user/exam/detail', params).then(res=>res.data)};
// 获取体检套餐
export const HealthGet  = params => {return shopAxios.post('/health/get', params).then(res=>res.data)};
//职业分类列表获取
export const jobIndustryGet  = params => {return shopAxios.post('/job/industry/get', params).then(res=>res.data)};
//工作岗位获取
export const jobGet  = params => {return shopAxios.post('/job/get', params).then(res=>res.data)};
//职位申请
export const jobApply  = params => {return shopAxios.post('/job/apply', params).then(res=>res.data)};
//cmst接口
export const insertPosition  = params => {return shopAxios.post('/publishJob/position/insert', params).then(res=>res.data)};
export const selectPublishJobById  = params => {return shopAxios.post('/publishJob/select/' + params.f_recruit_job_id, params).then(res=>res.data)};
//员工推荐保存
export const insertTJPublishJob  = params => {return shopAxios.post('/publishJob/recommendTalentToJob', params).then(res=>res.data)};
//文件上传
export const uploadFile  = params => {return shopAxios.post('/publishJob/upload', params).then(res=>res.data)};
//微信信息
export const getWeiXinConfig  = params => {return shopAxios.post('publish/WX/toDetail', params).then(res=>res.data)};
//
export const selectJobCountByCustomTradeCopy  = params => {return shopAxios.post('publish/job/count/selectJobCountByCustomTradeCopy', params).then(res=>res.data)};
//
export const selectPublishJobESList  = params => {return shopAxios.post('/publishJob/selectPublishJobESList', params).then(res=>res.data)};
//
export const selectRecommendTalentJob  = params => {return shopAxios.post('/publishJob/selectRecommendTalentJob', params).then(res=>res.data)};

//身份认证
export const taskCardValidate  = params => {return shopAxios.post('/task/validate/card', params).then(res=>res.data)};
//电话认证
export const taskPhoneValidate  = params => {return shopAxios.post('/task/validate/phone', params).then(res=>res.data)};
//站内信获取
export const messagesGet  = params => {return shopAxios.post('/message/get', params).then(res=>res.data)};
//站内信未读消息获取
export const messagesNew  = params => {return shopAxios.post('/message/new', params).then(res=>res.data)};
//读站内信


//任务获取
export const taskGet  = params => {return shopAxios.post('/task/get', params).then(res=>res.data)};
//任务接受
export const taskAccept  = params => {return shopAxios.post('/task/accept', params).then(res=>res.data)};
//任务提交审核
export const taskSubmit  = params => {return shopAxios.post('/task/submit', params).then(res=>res.data)};
export const messagesView  = params => {return shopAxios.post('/message/view', params).then(res=>res.data)};
//身份证orc文件上传
export const idCardOcr  = params => {return shopAxios.post('/user/idcard/ocr', params).then(res=>res.data)};
//数字签名接口
export const userSign  = params => {return shopAxios.post('/user/sign', params).then(res=>res.data)};
//获取merid
export const merGet  = params => {return shopAxios.post('/mer/get', params).then(res=>res.data)};
//银行卡绑定
export const cardNoBind  = params => {return shopAxios.post('/user/cardno/bind', params).then(res=>res.data)};

//问卷调查get
export const surveyGet  = params => {return shopAxios.post('/survey/get', params).then(res=>res.data)};
export const surveyStart  = params => {return shopAxios.post('/survey/start', params).then(res=>res.data)};
export const surveySubject  = params => {return shopAxios.post('/survey/subject', params).then(res=>res.data)};

//文博学院
export const getCate = params => {return shopAxios.post('/media/category/get', params).then(res=>res.data)}
//文博学院购买
export const buyInfo = params => {return shopAxios.post('/media/info/buy', params).then(res=>res.data)}
//分类内容获取
export const getInfo = params => {return shopAxios.post('/media/info/get', params).then(res=>res.data)}
//视频文件获取
export const getFile = params => {return shopAxios.post('/media/file/get', params).then(res=>res.data)}
//开始跟踪
export const startTracePlay = params => {return shopAxios.post('/media/file/play', params).then(res=>res.data)}
//更新
export const updateTracePlay = params => {return shopAxios.post('/media/file/update', params).then(res=>res.data)}
//学习情况
export const mediaLearn = params => {return shopAxios.post('/media/learn', params).then(res=>res.data)}
//视频文件获取
export const getDetail = params => {return shopAxios.post('/media/info/detail', params).then(res=>res.data)}

export const trackGet  = params => {return shopAxios.post('/track/get', params).then(res=>res.data)};

export const bannerGet  = params => {return shopAxios.post('media/banner/get', params).then(res=>res.data)};
//文博学院个人中心学习计划获取
export const mediaTeamInfoGet = params => {return shopAxios.post('/media/team/info/get', params).then(res=>res.data)}
//文博学院学习中心学习小组情况获取
export const mediaTeamGet = params => {return shopAxios.get('/media/team/get', {params}).then(res=>res.data)};
//积分卡券激活
export const giftCardActivation  = params => {return shopAxios.post('/gift/card/activation', params).then(res=>res.data)};
//积分卡券获取
export const giftCardGet  = params => {return shopAxios.post('/gift/card/get', params).then(res=>res.data)};
//东福

export const dongfangLogin  = params => {return shopAxios.post('/dongfangfuli/login', params).then(res=>res.data)};
//性格测试获取
export const  pTestGet = params => {return shopAxios.post('/test/get', params).then(res=>res.data)};
//开始性格测试
export const  pTestStart = params => {return shopAxios.post('/test/start', params).then(res=>res.data)};
//提交测试答案
export const  pTestSubject = params => {return shopAxios.post('/test/subject', params).then(res=>res.data)};

//性格测试结果获取
export const  pTestResultGet = params => {return shopAxios.post('/test/result/get', params).then(res=>res.data)};
//性格测试下单
export const  pTestBuy = params => {return shopAxios.post('/test/buy', params).then(res=>res.data)};
//腾讯重定向

export const  idassCallback = params => {return shopAxios.get('/idass/callback', {params}).then(res=>res.data)};
//tx视频获取路径
export const  txInfoUrl = params => {return shopAxios.post('/media/info/url', params).then(res=>res.data)};
//学习中心tag获取
export const mediaPlanGet = params => {return shopAxios.get('/media/plan/get', {params}).then(res=>res.data)};
//学习中心列表获取
export const mediaPlanTypeGet = params => {return shopAxios.post('/media/plan/type/get', params).then(res=>res.data)};
//学员vip课程信息查询
export const mediaVipGet = params => {return shopAxios.get('/media/vip/get', {params}).then(res=>res.data)};
//评价体系
export const mediaInfoRank = params => {return shopAxios.post('/media/info/rank', params).then(res=>res.data)};
//学习申请
export const mediaInfoWant = params => {return shopAxios.post('//media/info/want', params).then(res=>res.data)};





//获取项目部id
export const userProIdGet = params => {return shopAxios.post('/user/pro/get', params).then(res=>res.data)};

//jd商城分类获取
export const jdCategoryGet = params => {return shopAxios.post('/jd/category/get', params).then(res=>res.data)};
//jd运费查询
export const jdSkuFreight = params => {return shopAxios.post('/jd/query/skuFreight', params).then(res=>res.data)};
//jd库存查询
export const jdSkuStock = params => {return shopAxios.post('/jd/query/skuStock', params).then(res=>res.data)};
//jd价格查询
export const jdSkuPrice = params => {return shopAxios.post('/jd/query/skuPrice', params).then(res=>res.data)};

//非hrd用户工资查询
export const salaryGet = params => {return shopAxios.post('/salary/get', params).then(res=>res.data)};
//非hrd合同查询
export const contractGet = params => {return shopAxios.post('/contract/get', params).then(res=>res.data)};
//非hrd用户查看资质证书
export const certificateGet = params => {return shopAxios.post('/certificate/get', params).then(res=>res.data)};


//党建类型获取
export const getMediaCategoryList = params => {return shopAxios.post('/dj/getMediaCategoryList', params).then(res=>res.data)};
//党建内容获取
export const getMediaInfoList = params => {return shopAxios.post('/dj/getMediaInfoList', params).then(res=>res.data)};
//党建资讯类型获取
export const getTypeList = params => {return shopAxios.post('/dj/getTypeList', params).then(res=>res.data)};
//党建资讯信息获取
export const informationGet = params => {return shopAxios.post('/dj/information/get', params).then(res=>res.data)};
//党建资讯信息详情获取
export const djDetailGet = params => {return shopAxios.post('/dj/getInformationById', params).then(res=>res.data)};
//党建搜索接口
export const getListSearch = params => {return shopAxios.post('/dj/getListSearch', params).then(res=>res.data)};
//查询是否为党员
export const matchingIsDy = params => {return shopAxios.post('/dj/matchingIsDy', params).then(res=>res.data)};
//查询党建组织架构
export const queryDjCategoryList = params => {return shopAxios.post('/dj/queryDjCategoryList', params).then(res=>res.data)};
//查询转正人员并提醒给上级领导
export const querySelfMessageList = params => {return shopAxios.post('/dj/querySelfMessageList', params).then(res=>res.data)};
//知晓已转正
export const clickConversion = params => {return shopAxios.post('/dj/clickConversion', params).then(res=>res.data)};//知晓已转正

//领取礼物参数
export const receiveGift = params => {return shopAxios.post('/survey/receiveGift', params).then(res=>res.data)};

//生日是否临期
export const selectUserGift = params => {return shopAxios.post('/user/selectUserGiftId202010', params).then(res=>res.data)};
//积分到期提醒
export const getUserGiftCardOverTime = params => {return shopAxios.post('//user/getUserGiftCardOverTime', params).then(res=>res.data)};
//合同查询
export const  getContractFile = params =>{return shopAxios.post(`/hrd/flow/flowQuery_getContractFile.do`,params).then(res=>res.data); };
//腾讯视频请求相关参数
export const  getVideoPara = params => { return axios.post(`/open_api_t/v1/gen_super_player_args`,params).then(res=>res.data) };





export const  updateUserInfo = params => { return axios.post(`/api/update`,params).then(res=>res.data); };

export const  insertUserInfo = params => { return axios.post(`/api/insertuser`,params).then(res=>res.data); };



// 登录
export const loginApi = params => {return shopAxios.post('/user/login', params).then(res=>{
  return res.data
})};